import { InstructorTableCellType } from '@/enums/InstructorTableCellType';
export default class InstructorTableKidSchoolCell {
    cellType = InstructorTableCellType.KID_SCHOOL;
    hour;
    length;
    kidSchoolId;
    isLeader = false;
    toSaveObject() {
        return {
            ...this
        };
    }
    get calendarCaption() {
        return 'Školka';
    }
    get service() {
        return InstructorTableCellType.KID_SCHOOL;
    }
}
